import type { ReactNode } from 'react';
import { toast as sonnerToast } from 'sonner';

/**
 * Toast API shim over sonner. Preserves the object-shaped `toast({ title, description, variant })`
 * call signature used across the apps (and the error-handling pattern in CLAUDE.md), so callers
 * did not change when we migrated off the Radix toast. `variant: 'destructive'` maps to
 * sonner's error toast.
 */
type ToastVariant = 'default' | 'destructive';

export interface ToastOptions {
  title?: ReactNode;
  description?: ReactNode;
  variant?: ToastVariant;
}

function toast({ title, description, variant }: ToastOptions) {
  const message = title ?? description ?? '';
  const options = title && description ? { description } : undefined;

  if (variant === 'destructive') {
    return sonnerToast.error(message, options);
  }
  return sonnerToast(message, options);
}

function useToast() {
  return { toast, dismiss: sonnerToast.dismiss };
}

export { toast, useToast };
